module.exports = __webpack_public_path__ + "static/media/HOW TO MANAGE ADMISSION AND ADMISSION RELATED  RECORDS.05aa47bf.png";